import {
  ON_START_DELETE_LOBBY_FLODE,ON_DELETE_LOBBY_FLODE,ON_ERROR_DELETE_LOBBY_FLODE,
    ON_START_FETCH_FOLDE,
    ON_FETCH_FOLDE,
    ON_ERROR_FETCH_FOLDE,
    ON_START_NEW_FLODE,
    ON_NEW_FLODE,
    ON_ERROR_NEW_FLODE,
    ON_START_FETCH_TODOLIST,
    ON_FETCH_TODOLIST,
    ON_ERROR_FETCH_TODOLIST,
} from "../constants/ActionTypes";
import axios from 'util/Api' 
import { isEmpty,isUndefined } from "lodash";
import {userSignOut} from 'actions'
import {RefreshUserInterface} from 'actions'
import {encrypt,decrypt} from 'actions'



////dispatch(RefreshUserInterface(userid))
//getFlodeByUser
export const getFlodeByUser = (userid,Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_FETCH_FOLDE});
      axios.get('kontos/Intranet/getFlodeBu',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,ipAdress})), 
       headers: { 'Authorization': `Bearer ${jwt}`} }      
       ).then( data  => {
        console.log("getFlodeByUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getFlodeByUser1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_FOLDE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getFlodeByUser2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_FOLDE, payload: ndate.error});
        }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_FOLDE, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
    }
  }
//addNowFlodeByUser
export const addNowFlodeByUser = (userid,Nflode,Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
      const ipAdress='0.0.0.0'
       dispatch({type: ON_START_NEW_FLODE});
       axios.put('kontos/Intranet/newFlodeBu', {
        body: encrypt(JSON.stringify({
            flode:Nflode,
            userid:userid,
            Afid:Afid,ipAdress
        }))}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then( data => {
        console.log("addNowFlodeByUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("addNowFlodeByUser1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_NEW_FLODE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("addNowFlodeByUser2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_NEW_FLODE, payload: ndate.error});
        }
       }).catch(function (error) {
         dispatch({type: ON_ERROR_NEW_FLODE, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
     }
   } 
   //Like FlodeByUser
export const likeFlodeByUser = (userid,FlodeId,Afid, Type) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
      const ipAdress='0.0.0.0'
       dispatch({type: ON_START_NEW_FLODE});
       axios.put('kontos/Intranet/LikeFlodeBu', {
        body: encrypt(JSON.stringify({
            flodeid:FlodeId,
            userid:userid,
            Afid:Afid,ipAdress,
            Type:Type
        }))}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then( data => {
        console.log("likeFlodeByUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("likeFlodeByUser1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_NEW_FLODE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("likeFlodeByUser2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_NEW_FLODE, payload: ndate.error});
        }
       
       }).catch(function (error) {
         dispatch({type: ON_ERROR_NEW_FLODE, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
     }
   } 
   //Remove like by user
export const removelikeFlodeByUser = (userid,FlodeId,Afid, Type) =>{
    const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
      const ipAdress='0.0.0.0'
       dispatch({type: ON_START_NEW_FLODE});
       axios.put('kontos/Intranet/removeLikeFlodeBu', {
        body: encrypt(JSON.stringify({
            flodeid:FlodeId,
            userid:userid,
            Afid:Afid,ipAdress, Type:Type
        }))}, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then( data => {
        console.log("likeFlodeByUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("addArtikel1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_NEW_FLODE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("addArtikel2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_NEW_FLODE, payload: ndate.error});
        }
       
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
         dispatch({type: ON_ERROR_NEW_FLODE, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
     }
   } 

//getToDoListByUser
export const getToDoListByUser = (userid,Afid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_FETCH_TODOLIST});
    axios.get('kontos/Intranet/ToDoList',
    { params:encrypt(JSON.stringify({userid:userid,ipAdress,Afid})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getFlodeByUser: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikel1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TODOLIST, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikel2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_TODOLIST, payload: ndate.error});
      }
       dispatch(RefreshUserInterface(userid,1))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_TODOLIST, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}
//onDelectLobbyFlode
export const onDelectLobbyFlode = (userid,Afid,Post) =>{
  const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_DELETE_LOBBY_FLODE});
    axios.delete('kontos/Intranet/Flode/delete', {
      method: 'DELETE',
      data: encrypt(JSON.stringify({Post:JSON.stringify(Post),Afid,userid})),
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then( data => {
    console.log("onDelectLobbyFlode: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("onDelectLobbyFlode1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_DELETE_LOBBY_FLODE, payload: ndate.results});
      dispatch(getFlodeByUser(userid,Afid))
    }
    else {
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("onDelectLobbyFlode2: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_DELETE_LOBBY_FLODE, payload: ndate.error});
    }
   
   }).catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_LOBBY_FLODE, payload: error.message});
     console.log("Error****:", error.message);
       
     if(error.message === "Network Error"){
      //reload and remove token 
      //dispatch(userSignOut())
   }
   });
  }
}

